// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import etask from '/util/etask.js';
import recaptcha from '/www/lum/pub/util/recaptcha.js';
import {get_path, call_api, notify_error, ls_get,
    parse_url_state} from '@pub/util.js';
import {ROUTES, LOCAL_STORAGE_KEYS} from '@pub/constants.js';
import * as api from '@pub/api.js';
import {shorten_promo, shorten_ref, get_error} from './common.js';
import {ACTION, UNKNOWN_ERROR, AUTH_ERROR, EMAIL_FIELD, promo_code,
    ref_code} from './constants.js';

const get_redirect_path = target=>{
    let tg = target;
    if (!tg)
    {
        const saved_state = parse_url_state();
        const s_redirect = saved_state.redirect;
        if (s_redirect?.[0]=='/' && s_redirect?.[1]!='/')
            tg = s_redirect;
    }
    return tg || get_path(ROUTES.DASHBOARD);
};

const show_auth_error = code=>
    notify_error(AUTH_ERROR[code]||AUTH_ERROR[UNKNOWN_ERROR]);

const do_redirect = target=>{
    window.location.href = get_redirect_path(target);
};

const sign_in = data=>etask(function*(){
    try {
        const res = yield api.login2({...data, method: 'password'});
        return {ok: !!res.user, code: res.error};
    } catch(e){
        return {ok: false, code: UNKNOWN_ERROR};
    }
});

const finalize_signin = ()=>{
    do_redirect();
};

const do_signup = data=>etask(function*(){
    try {
        yield call_api(()=>api.signup(data), {do_throw: true});
        return {ok: true, code: null};
    } catch(e){
        return {ok: false, code: e.xhr_info?.data || UNKNOWN_ERROR};
    }
});

export const handle_signup = data=>etask(function*(){
    let check_res;
    try {
        check_res = yield sign_in(data);
        if (check_res.ok)
            return finalize_signin();
        const utm = ls_get(LOCAL_STORAGE_KEYS.utm_map);
        const origin_url = ls_get(LOCAL_STORAGE_KEYS.origin_url);
        const form_data = {...data, utm, origin_url};
        if (promo_code)
            form_data.promo_code = shorten_promo(promo_code);
        if (ref_code)
            form_data.ref_code = shorten_ref(ref_code);
        const recaptcha_token = yield recaptcha.new_token(ACTION.SIGNUP);
        if (recaptcha_token)
            form_data.recaptcha = recaptcha_token;
        const res = yield do_signup(form_data);
        if (!res.ok)
            throw get_error(res.code);
        do_redirect(ROUTES.AUTH_EMAIL_VERIFY);
    } catch(e){
        const code = check_res?.code==UNKNOWN_ERROR ? e.code : check_res?.code;
        show_auth_error(code);
        throw e;
    }
});

export const handle_signin = data=>etask(function*(){
    try {
        const check_res = yield sign_in(data);
        if (!check_res.ok)
            throw get_error(check_res.code);
        finalize_signin();
    } catch(e){
        show_auth_error(e.code);
        throw e;
    }
});

export const handle_reset = data=>etask(function*(){
    const email = data[EMAIL_FIELD];
    try {
        yield call_api(()=>api.reset_pass(email), {do_throw: true});
    } catch(e){
        notify_error('Error happened while sending reset password link');
        console.error(e);
        throw e;
    }
});
